/* eslint-disable no-unexpected-multiline */
import React, { useState, useEffect } from 'react'

import { ReactComponent as CsnLogo } from 'assets/images/logo_csn.svg'
import Logotipo from 'assets/images/logotipo_csn.png'
import {
  Card,
  Row,
  SimpleCollapse,
  Span,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Col,
  Button,
  Image,
  PageFooter
} from 'components'
import { ExcelIcon, PdfIcon } from 'components/Svg'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import { useLoading, useToggle, useReportPrint, useModal } from 'hooks'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import {
  Grupo,
  GrupoIten,
  IRelatorioTtl,
  ReportsEffectivesNGTServices
} from 'services/NGT/ReportsEffectives'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'

// import html2canvas from 'html2canvas';
import { IRequestBody } from '../ReportsEffectives/ReportsEffectives'
import { TableReportsSupplier } from './components'
import FormatarNumeros from 'utils/formatNumbers'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Box, LinearProgress } from '@mui/material'

interface location {
  request_body: any
  name: any
  hash: string
  pathname: string
  search: string
  state: {
    name: string
    request_body: IRequestBody
  }
}

const DEFAULT_ERROR = 'Erro ao obter relatório.'
const DEFAULT_SCROLL_LOAD_ITEMS = 20

const ReportsSupplier: React.FC = () => {
  const { setLoading } = useLoading()
  const { handlePrintEfetivosTerceirosPorFornecedor } = useReportPrint()
  const history = useHistory()
  const location = useLocation<location>()
  const [isError, toggleErrorModal] = useToggle()
  const { showModal } = useModal()

  const [excelProp, setExcelProp] = useState()
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    DEFAULT_ERROR
  )
  const [dataCompetenciaIni, setDataCompetenciaIni] = useState<string>('')
  const [dataCompetenciaFim, setDataCompetenciaFim] = useState<string>('')
  const [slicedList, setSlicedList] = useState<Grupo<GrupoIten>[]>([])
  const [tableDataResponse, setTableDataResponse] = useState<IRelatorioTtl>({
    grupos: [],
    totalGeral: {
      cdContrato: '',
      competencia: '',
      dataCompFim: '',
      dataCompInicio: '',
      diretoria: '',
      diretoriaExecutiva: '',
      flStatusMobilizacao: '',
      gerencia: '',
      gerenciaGeral: '',
      grupo: '',
      nmFornecedor: '',
      qtAcesso: 0,
      qtAfastado: 0,
      qtAtivo: 0,
      qtCompartilhado: 0,
      qtDemitido: 0,
      qtTotalEfetivoComDemitido: 0,
      qtTotalEfetivoSemDemitido: 0,
      qtTransferido: 0
    }
  })

  const mesInicial = moment(
    location.state.request_body.competenciaDataIni
  ).isValid()
    ? moment(location.state.request_body.competenciaDataIni).format('MM/YYYY')
    : '---'
  const mesFinal = moment(
    location.state.request_body.competenciaDataFim
  ).isValid()
    ? moment(location.state.request_body.competenciaDataFim).format('MM/YYYY')
    : '---'

  const handleView = () => {
    setLoading('loading')

    ReportsEffectivesNGTServices()
      [location.state.name](location.state.request_body)
      .then((response) => {
        setLoading('idle')

        if (!response?.data?.sucesso) {
          if (response?.data?.mensagem) {
            setErrorMessage(response?.data?.mensagem)
          }
          toggleErrorModal()
          return
        } else {
          setSlicedList(
            response.data?.entity?.grupos?.slice(0, DEFAULT_SCROLL_LOAD_ITEMS)
          )

          // setDataCompetenciaIni(
          //   response.data.entity.grupos[0].grupoItens[0].dataCompIni
          // )
          // setDataCompetenciaFim(
          //   response.data.entity.grupos[0].grupoItens[0].dataCompFim
          // )
          setDataCompetenciaIni(mesInicial)
          setDataCompetenciaFim(mesFinal)

          setTableDataResponse(response.data.entity)
          setExcelProp(response.data)
        }
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message:
            error.mensagem || error.message || 'Falha ao obter relatório.',
          txtButtonConfirm: 'Fechar',
          type: 'error'
        })
        return
      })
  }

  const compareCompetencias = (
    firstValue?: string,
    secondValue?: string
  ): number => {
    const sorting = firstValue
      ?.substring(3, 7)
      .localeCompare(secondValue?.substring(3, 7))

    if (sorting !== 0) {
      return sorting
    }

    return firstValue
      ?.substring(0, 2)
      ?.localeCompare(secondValue?.substring(0, 2))
  }

  const handleExcel = () => {
    ReportsEffectivesNGTServices()
      .RelatorioExcel(excelProp, location.state.name)
      .then((response) => {
        const url =
          'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
          response.data
        const downloadLink = document.createElement('a')
        downloadLink.href = url
        downloadLink.download =
          'RELATORIO-EFETIVOS-DE-TERCEIROS-POR-FORNECEDOR.xlsx'
        document.body.appendChild(downloadLink)
        downloadLink.click()
        document.body.removeChild(downloadLink)
      })
  }

  const nextPagination = (grupos: Grupo<GrupoIten>[]) => {
    setTimeout(() => {
      const currentLength = slicedList.length
      const newItems = grupos.slice(
        currentLength,
        currentLength + DEFAULT_SCROLL_LOAD_ITEMS
      )
      setSlicedList((prevState) => prevState.concat([...newItems]))
    }, 1000)
  }

  const HeaderSupplierTitle = () => (
    <Card
      backgroundColor={COLORS.headerColor}
      padding={SPACING.spacing20}
      marginBottom={`-${SPACING.spacing15}`}
    >
      <Row alignItems="center" justifyContent="left">
        <Col gap=".7rem" alignItems="center" justifyContent="left">
          <CsnLogo width="62" height="40" />
          <Image src={Logotipo} width="3.8rem" />
        </Col>
      </Row>
      <Span
        text="EFETIVOS DE TERCEIROS POR FORNECEDOR"
        color={COLORS.blueFonts}
        fontSize="24px"
        fontWeight={FONTS.bold}
        textTransform="uppercase"
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      />
    </Card>
  )

  useEffect(() => {
    handleView()
  }, [])

  return (
    <>
      <Card
        marginTop={SPACING.spacing5}
        marginLeft={SPACING.spacing5}
        marginRight={SPACING.spacing5}
        marginBottom={SPACING.spacing100}
        padding={SPACING.spacing20}
        id="divToPrint"
      >
        <HeaderSupplierTitle />
        <Card backgroundColor={COLORS.primary} padding="8px 0">
          <Row alignItems="center" justifyContent="center">
            <Span
              text={`Mês Inicial: ${mesInicial}`}
              marginRight={SPACING.spacing50}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
            />
            <Span
              text={`Mes Final: ${mesFinal}`}
              fontWeight={FONTS.bold}
              fontSize={TYPOGRAPHY.bodySize16}
            />
          </Row>
        </Card>
        <Row justifyContent="flex-end" marginTop="5px">
          <>
            <Button
              text="Voltar"
              marginRight={SPACING.spacing15}
              variantButton="text"
              onClick={() => {
                history.push({
                  pathname: '/ngt/relatorios-efetivos'
                })
              }}
            />
            <a>
              <ExcelIcon onClick={handleExcel} />
            </a>
            <PdfIcon
              onClick={() =>
                handlePrintEfetivosTerceirosPorFornecedor({
                  data: {
                    content: tableDataResponse?.grupos.map((contract) => ({
                      body: contract.grupoItens
                        .map((grupo) => [
                          grupo?.cdContrato,
                          // grupo?.competencia,
                          grupo?.flStatusMobilizacao,
                          grupo?.diretoriaExecutiva || '-',
                          grupo?.diretoria || '-',
                          grupo?.gerenciaGeral || '-',
                          grupo?.gerencia || '-',
                          grupo?.qtAtivo,
                          grupo?.qtDemitido,
                          grupo?.qtAcesso,
                          grupo?.qtTransferido,
                          grupo?.qtAfastado,
                          grupo?.qtCompartilhado,
                          `${grupo?.qtTotalEfetivoComDemitido} - ${grupo?.qtTotalEfetivoSemDemitido}`,
                          grupo?.nmContraparte
                        ])
                        .slice(0, -1),
                      footer: (() => {
                        const subTotal = contract.grupoItens.find(
                          (contract) => contract.grupo === 'SubTotal'
                        )

                        return [
                          formatarNumero(subTotal?.qtAtivo),
                          formatarNumero(subTotal?.qtDemitido),
                          formatarNumero(subTotal?.qtAcesso),
                          formatarNumero(subTotal?.qtTransferido),
                          formatarNumero(subTotal?.qtAfastado),
                          formatarNumero(subTotal?.qtCompartilhado),
                          `${formatarNumero(
                            subTotal.qtTotalEfetivoComDemitido
                          )} - ${formatarNumero(
                            subTotal.qtTotalEfetivoSemDemitido
                          )}`
                        ]
                      })(),
                      nmFornecedor: contract.chaveGrupo
                    })),
                    mesFinal: mesFinal || dataCompetenciaFim || '---',
                    mesInicial: mesInicial || dataCompetenciaIni || '---',
                    title: 'RELATÓRIO DE EFETIVOS POR FORNECEDOR',
                    totalGeral: [
                      formatarNumero(tableDataResponse?.totalGeral?.qtAtivo),
                      formatarNumero(tableDataResponse?.totalGeral?.qtDemitido),
                      formatarNumero(tableDataResponse?.totalGeral?.qtAcesso),
                      formatarNumero(
                        tableDataResponse?.totalGeral?.qtTransferido
                      ),
                      formatarNumero(tableDataResponse?.totalGeral?.qtAfastado),
                      formatarNumero(
                        tableDataResponse?.totalGeral?.qtCompartilhado
                      ),
                      `${formatarNumero(
                        tableDataResponse?.totalGeral?.qtTotalEfetivoComDemitido
                      )} - ${formatarNumero(
                        tableDataResponse?.totalGeral?.qtTotalEfetivoSemDemitido
                      )}`
                    ]
                  },
                  filename: `relatório-de-efetivos-por-fornecedor-${moment().format(
                    'DD-MM-YYYY'
                  )}`
                })
              }
            />
          </>
        </Row>
        <InfiniteScroll
          dataLength={slicedList.length}
          next={() => nextPagination(tableDataResponse.grupos)}
          hasMore={tableDataResponse.grupos.length > slicedList.length}
          loader={
            <Box sx={{ width: '100%', marginBottom: '20px' }}>
              <LinearProgress />
            </Box>
          }
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>Final da listagem</b>
            </p>
          }
          releaseToRefreshContent={
            <h3 style={{ textAlign: 'center' }}>&#8593; Atualizando...</h3>
          }
        >
          {slicedList?.map((contract) => (
            <SimpleCollapse
              data-html2canvas-ignore="true"
              key={contract.chaveGrupo}
              title={`Fornecedor: ${contract.chaveGrupo}`}
              textColor={COLORS.black}
            >
              <Row alignItems="center" justifyContent="center">
                <Span
                  text="MÃO DE OBRA"
                  textAlign="center"
                  color={COLORS.blueFonts}
                  fontSize="24px"
                  fontWeight="700"
                />
              </Row>

              <TableReportsSupplier
                tableData={contract.grupoItens.sort((first, second) =>
                  compareCompetencias(first.competencia, second.competencia)
                )}
              />
            </SimpleCollapse>
          ))}
        </InfiniteScroll>
        <Box margin="0 1rem 0 1rem">
          <PageFooter bottomPosition="55px">
            <TableContainerStyled style={{ marginTop: 0 }}>
              <TableStyled>
                <TableHeadStyled>
                  <TableRowStyled>
                    <TableCellStyled></TableCellStyled>
                    <TableCellStyled align="center"></TableCellStyled>
                    <TableCellStyled align="center"></TableCellStyled>
                    <TableCellStyled align="center"></TableCellStyled>
                    <TableCellStyled align="center"></TableCellStyled>
                    <TableCellStyled align="center"></TableCellStyled>
                    <TableCellStyled align="center">Ativo</TableCellStyled>
                    <TableCellStyled align="center">Demitido</TableCellStyled>
                    <TableCellStyled align="center">Acesso</TableCellStyled>
                    <TableCellStyled align="center">
                      Transferido
                    </TableCellStyled>
                    <TableCellStyled align="center">Afastado</TableCellStyled>
                    <TableCellStyled align="center">
                      Compartilhado
                    </TableCellStyled>
                    <TableCellStyled align="center">
                      <Col>
                        Total Efetivo
                        <Row justifyContent="center" alignItems="center">
                          <TableCellStyled align="center">
                            Com Demitido
                          </TableCellStyled>
                          <TableCellStyled align="center">
                            Sem demitido
                          </TableCellStyled>
                        </Row>
                      </Col>
                    </TableCellStyled>
                    <TableCellStyled align="center"></TableCellStyled>
                  </TableRowStyled>
                </TableHeadStyled>

                <TableRowStyled style={{ background: COLORS.lightGray }}>
                  <TableCellStyled style={{ fontWeight: 'bold' }}>
                    Total Geral
                  </TableCellStyled>
                  <TableCellStyled></TableCellStyled>
                  <TableCellStyled></TableCellStyled>
                  <TableCellStyled></TableCellStyled>
                  <TableCellStyled></TableCellStyled>
                  <TableCellStyled></TableCellStyled>
                  <TableCellStyled align="center">
                    {formatarNumero(tableDataResponse?.totalGeral?.qtAtivo)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {formatarNumero(tableDataResponse?.totalGeral?.qtDemitido)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {formatarNumero(tableDataResponse?.totalGeral?.qtAcesso)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {formatarNumero(
                      tableDataResponse?.totalGeral?.qtTransferido
                    )}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {formatarNumero(tableDataResponse?.totalGeral?.qtAfastado)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {formatarNumero(
                      tableDataResponse?.totalGeral?.qtCompartilhado
                    )}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Row justifyContent="center" alignItems="center">
                      <TableCellStyled align="center">
                        {formatarNumero(
                          tableDataResponse?.totalGeral
                            ?.qtTotalEfetivoComDemitido
                        )}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {formatarNumero(
                          tableDataResponse?.totalGeral
                            ?.qtTotalEfetivoSemDemitido
                        )}
                      </TableCellStyled>
                    </Row>
                  </TableCellStyled>
                  <TableCellStyled></TableCellStyled>
                </TableRowStyled>
              </TableStyled>
            </TableContainerStyled>
          </PageFooter>
        </Box>
      </Card>
      <SuccessModal
        message={errorMessage}
        open={isError}
        type={errorMessage == DEFAULT_ERROR ? 'error' : 'alert'}
        handleConfirm={() => {
          toggleErrorModal()
          history.push({
            pathname: '/ngt/relatorios-efetivos'
          })
        }}
        txtButtonConfirm="OK"
        hideButtonCancel
      />
    </>
  )
}

function formatarNumero(numero: number) {
  return FormatarNumeros.formatarNumero(numero) as unknown as number
}

export default ReportsSupplier
